var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _class2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { attr, hasMany } from '@ember-data/model';
import { alias } from '@ember/object/computed';
import { computed } from '@ember/object';
import { fragment } from 'ember-data-model-fragments/attributes';
import { inject as service } from '@ember/service';
import CatalogObject, { CatalogObjectType } from '@square/dashboard-items-data/models/connect/catalog-object';
import { CatalogObjectType as CatalogObjectTypeProto } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
export const SUBSCRIPTION_ITEMIZATION_API_VERSION = '2023-06-08';
let SubscriptionPlan = (_dec = attr('string', {
  defaultValue: CatalogObjectType.SUBSCRIPTION_PLAN,
  protoEnum: CatalogObjectTypeProto
}), _dec2 = fragment('connect/subscription-plan/data', {
  defaultValue: {}
}), _dec3 = hasMany('connect/subscription-plan/plan-variation', {
  async: false
}), _dec4 = computed('subscriptionPlanData', 'subscriptionPlanVariations.lastObject.subscriptionPlanVariationData'), _dec5 = alias('subscriptionPlanData.name'), _dec6 = alias('legacyPlanData.checkoutLink'), _dec7 = alias('legacyPlanData.phases'), _dec8 = alias('subscriptionPlanData.canProrate'), _dec9 = alias('subscriptionPlanData.eligibleItemIds'), _dec10 = alias('subscriptionPlanData.eligibleCategoryIds'), _dec11 = alias('subscriptionPlanData.allItems'), _dec12 = alias('subscriptionPlanData.monthlyBillingAnchorDate'), _dec13 = alias('legacyPlanData.configuration'), _dec14 = hasMany('connect/item', {
  async: true
}), (_class = (_class2 = class SubscriptionPlan extends CatalogObject {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "features", _descriptor, this);
    _initializerDefineProperty(this, "type", _descriptor2, this);
    _initializerDefineProperty(this, "subscriptionPlanData", _descriptor3, this);
    _initializerDefineProperty(this, "subscriptionPlanVariations", _descriptor4, this);
    _initializerDefineProperty(this, "name", _descriptor5, this);
    _initializerDefineProperty(this, "checkoutLink", _descriptor6, this);
    _initializerDefineProperty(this, "phases", _descriptor7, this);
    _initializerDefineProperty(this, "canProrate", _descriptor8, this);
    _initializerDefineProperty(this, "eligibleItemIds", _descriptor9, this);
    _initializerDefineProperty(this, "eligibleCategoryIds", _descriptor10, this);
    _initializerDefineProperty(this, "allItems", _descriptor11, this);
    _initializerDefineProperty(this, "monthlyBillingAnchorDate", _descriptor12, this);
    _initializerDefineProperty(this, "subscriptionConfiguration", _descriptor13, this);
    _initializerDefineProperty(this, "items", _descriptor14, this);
  }
  get legacyPlanData() {
    return this.features.isEnabled('buyersubs/updated_legacy_api_version') && this.subscriptionPlanVariations.lastObject ? this.subscriptionPlanVariations.lastObject.subscriptionPlanVariationData : this.subscriptionPlanData;
  }
  get isDeactivated() {
    if (this.subscriptionPlanVariations.length === 1) {
      return !this.presentAtAllLocations || !this.subscriptionPlanVariations?.firstObject?.presentAtAllLocations;
    }
    return !this.presentAtAllLocations;
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'connect/subscription-plan'), _class2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "type", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "subscriptionPlanData", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "subscriptionPlanVariations", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "legacyPlanData", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "legacyPlanData"), _class.prototype), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "checkoutLink", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "phases", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "canProrate", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "eligibleItemIds", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "eligibleCategoryIds", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "allItems", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "monthlyBillingAnchorDate", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "subscriptionConfiguration", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "items", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { SubscriptionPlan as default };